var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0315 1.83568C17.708 1.57692 17.6556 1.10495 17.9143 0.781506C18.1731 0.45806 18.6451 0.405619 18.9685 0.664376L21.4685 2.66438C21.792 2.92313 21.8444 3.3951 21.5857 3.71855C21.3269 4.042 20.8549 4.09444 20.5315 3.83568L18.0315 1.83568Z",
    fill: "#001F06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03148 0.664376C5.35493 0.405619 5.82689 0.45806 6.08565 0.781506C6.34441 1.10495 6.29197 1.57692 5.96852 1.83568L3.46852 3.83568C3.14507 4.09444 2.67311 4.042 2.41435 3.71855C2.15559 3.3951 2.20803 2.92313 2.53148 2.66438L5.03148 0.664376Z",
    fill: "#001F06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.00003C11.25 7.58581 11.5858 7.25003 12 7.25003C12.4142 7.25003 12.75 7.58581 12.75 8.00003L12.75 11.1894L13.4697 10.4697C13.7626 10.1768 14.2374 10.1768 14.5303 10.4697C14.8232 10.7626 14.8232 11.2375 14.5303 11.5304L13.0303 13.0304C12.3733 13.6873 11.25 13.222 11.25 12.2929L11.25 8.00003Z",
    fill: "#001F06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25003C17.9371 1.25003 22.75 6.06297 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06297 6.06294 1.25003 12 1.25003ZM21.25 12C21.25 6.89139 17.1086 2.75003 12 2.75003C6.89137 2.75003 2.75 6.89139 2.75 12C2.75 17.1087 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1087 21.25 12Z",
    fill: "#001F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPlaces);
export default __webpack_public_path__ + "static/media/previous_places.3d1dfd693d5275906d75f1cff5320cda.svg";
export { ForwardRef as ReactComponent };